var map = {
	"./fronius.png": "f5ee",
	"./kostal.png": "b8e3",
	"./meteoblue.png": "eedb",
	"./slideshow.png": "67ba",
	"./sma.png": "d32b",
	"./solaredge.png": "1e2c",
	"./solarfox.png": "dd0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f52";